/**
 * Utility functions for managing service authentication
 */

export interface ServiceAuthData {
  token: string;
  id: string;
  email: string;
  nickname: string;
  name?: string;
  phone?: string;
  service_tier?: string;
  has_premium_access?: boolean;
}

/**
 * Store service authentication data and notify all components
 */
export const storeServiceAuth = (userData: ServiceAuthData) => {
  console.log('[ServiceAuth] Storing service auth data:', userData);
  
  // Store in localStorage
  localStorage.setItem('serviceAuthenticated', 'true');
  localStorage.setItem('serviceToken', userData.token);
  localStorage.setItem('serviceUserData', JSON.stringify(userData));
  
  // Verify storage
  const storedToken = localStorage.getItem('serviceToken');
  const storedData = localStorage.getItem('serviceUserData');
  console.log('[ServiceAuth] Verification - Token stored:', !!storedToken);
  console.log('[ServiceAuth] Verification - UserData stored:', !!storedData);
  
  // Dispatch custom event to notify all listeners in the same tab
  window.dispatchEvent(new Event('serviceAuthChanged'));
};

/**
 * Clear service authentication data and notify all components
 */
export const clearServiceAuth = () => {
  // Clear from localStorage
  localStorage.removeItem('serviceAuthenticated');
  localStorage.removeItem('serviceToken');
  localStorage.removeItem('serviceUserData');
  localStorage.removeItem('userEmail');
  localStorage.removeItem('userPin');
  
  // Dispatch custom event to notify all listeners in the same tab
  window.dispatchEvent(new Event('serviceAuthChanged'));
};

/**
 * Check if user is authenticated via service
 */
export const isServiceAuthenticated = (): boolean => {
  return !!localStorage.getItem('serviceToken');
};

/**
 * Get current service user data
 */
export const getServiceUserData = (): ServiceAuthData | null => {
  const data = localStorage.getItem('serviceUserData');
  if (!data) return null;
  
  try {
    return JSON.parse(data);
  } catch {
    return null;
  }
};